/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { Address } from './address';
import { Column, Row } from '../../layout/flexbox';
import { BLACK, DARK_GREY } from '../../styles/colors';
import * as R from 'ramda';
import { isNilOrEmpty } from '../../language/module';
import { MediumText, SmallText } from '../../styles/styles';
import { getResource } from '../../language/resources/getResource';


const textStyle = css`
  display: block;
  
  &:not(&:last-child) {
    margin-bottom: 5px;
  }
`;

const AddressLine = styled('span')`
  ${SmallText}; 
  color: ${BLACK};
  ${textStyle};
`;

const AddressLineNoData = styled('span')`
  ${SmallText}; 
  color: ${DARK_GREY};
  ${textStyle};
`;

/**
 * AddressView: a component that
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class AddressView extends React.PureComponent<{
  address: Address | undefined,
  rootCss?: SerializedStyles,
  resources: Record<string, any>,
}> {
  private isEmpty = (
    address: Address,
  ) => !address.line1
       && !address.line2
       && !address.city
       && !address.state
       && !address.country
       && !address.postalCode;

  private makeAddressLine = (
    title,
    id,
    value,
    noValueMsg,
  ) => R.isEmpty((value || '').replace(',', '').trim())
       ? <AddressLineNoData title={title} id={id}>{noValueMsg}</AddressLineNoData>
       : <AddressLine title={title} id={id}>{value}</AddressLine>;


  public render() {
    if (!this.props.address || this.isEmpty(this.props.address)) {
      return <span title={getResource(this.props.resources, 'ADDRESS_NO_ADDRESS_TITLE')} id="address1" css={css`
        ${MediumText};
        ${this.props.rootCss};
      `}>{getResource(this.props.resources, 'ADDRESS_NO_ADDRESS')}</span>;
    }

    return (
      <Column flexWrap='wrap' rootCss={this.props.rootCss}>
        {this.makeAddressLine(getResource(this.props.resources, 'ADDRESS_LINE_ONE'), 'address1', this.props.address.line1, getResource(this.props.resources, 'ADDRESS_NO_DATA'))}
        {
          !isNilOrEmpty(this.props.address.line2)
          && this.makeAddressLine(getResource(this.props.resources, 'ADDRESS_LINE_TWO'), 'address2',  this.props.address.line2, '')
        }
        <Row>
          {this.makeAddressLine(getResource(this.props.resources, 'ADDRESS_CITY'), 'city',  this.props.address.city + ', ', getResource(this.props.resources, 'ADDRESS_NO_CITY'))}&nbsp;
          {this.makeAddressLine(getResource(this.props.resources, 'ADDRESS_STATE'), 'state',  this.props.address.state, getResource(this.props.resources, 'ADDRESS_NO_STATE'))}
        </Row>
        <Row>
          {this.makeAddressLine(getResource(this.props.resources, 'ADDRESS_POSTAL'), 'postal',  this.props.address.postalCode + ', ', getResource(this.props.resources, 'ADDRESS_NO_POSTAL'))}&nbsp;
          {this.makeAddressLine(getResource(this.props.resources, 'ADDRESS_COUNTRY'), 'country',  this.props.address.country, getResource(this.props.resources, 'ADDRESS_NO_COUNTRY'))}
        </Row>
      </Column>
    );
  }
}
